import React from "react";

export default function SectionShell({ className = "", children }) {
  return (
    <section className={`${className}`}>
      <div >{children}</div>
    </section>
  );
}
